import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';

import { ApiError, apiClient, fleetPath } from '@/lib/api-client';

import { fleetKeys } from './fleet-keys';

/** Result of POST /regions/:region/deploy-thin-exit — the dispatched task. */
export interface DeployThinExitResult {
  task_id: number;
  status_url: string;
  /** Region the playbook was dispatched for (echoed, trimmed by the API). */
  region: string;
}

/**
 * POST /regions/:region/deploy-thin-exit — manually scale out a region by
 * dispatching the "Deploy Thin Exit" playbook. The operator-driven twin of the
 * autoscaler's VPNRegionLowCapacity remediation. A 400 (bad region) / 502
 * (template not registered) surfaces as an ApiError.
 */
export function useDeployThinExit(): UseMutationResult<DeployThinExitResult, ApiError, string> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (region) =>
      apiClient.post<DeployThinExitResult>(
        fleetPath(`/regions/${encodeURIComponent(region)}/deploy-thin-exit`),
        {},
      ),
    onSuccess: () => {
      // New capacity lands in the fleet — refresh lists, summary + region views.
      void queryClient.invalidateQueries({ queryKey: fleetKeys.all });
    },
  });
}
